<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
        <div
            class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
            <div class="d-sm-flex align-items-center">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                    <label class="d-block text-black fw-semibold mb-10">
                        Mot clé
                    </label>
                    <Field v-model="motCle" name="mot" type="text" :disabled="isLoading"
                        class="form-control shadow-none fs-md-15 text-black" placeholder="Recherche par mot clé" />
                    <ErrorMessage name="mot" class="text-danger" />
                </div>
            </div>
            <div class="d-sm-flex align-items-center">
                <button @click="telecharger" v-if="valideEtape3" :disabled="isLoading"
                    class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
                    type="button">
                    <i class="flaticon-download position-relative ms-5 fs-12"></i>
                    <span v-if="!isLoading">Exporter</span>
                    <span v-else>
                        <span class="spinner-grow spinner-grow-sm me-2" role="status" aria-hidden="true"></span>
                        Export en cours...
                    </span>
                </button>
                <button
                    class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-secondary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
                    type="button" v-if="!valideEtape3" disabled>
                    <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                    <span class="visually-hidden">Chargement...</span>
                </button>
            </div>
        </div>
        <div class="card-body p-15 p-sm-20 p-md-25 position-relative">
            <!-- Loader overlay pour tout le composant -->
            <div v-if="isLoading" class="position-absolute w-100 h-100 d-flex align-items-center justify-content-center bg-white bg-opacity-95" style="z-index: 1000; top: 0; left: 0; min-height: 100%; border-radius: 8px;">
                <div class="text-center">
                    <div class="spinner-border text-primary mb-3" role="status" style="width: 3rem; height: 3rem;">
                        <span class="visually-hidden">Chargement...</span>
                    </div>
                    <h5 class="text-muted mb-2">Chargement des données...</h5>
                    <p class="text-muted small">Veuillez patienter pendant que nous récupérons les informations.</p>
                </div>
            </div>
            
            <div class="col-md-12">
                <div class="row">
                    <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xm-12">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Marches
                            </label>
                            <Field name="marche" v-model="marches" v-slot="{ field }">
                                <Multiselect mode="tags" :options="marcheOptions" :searchable="true" v-bind="field"
                                    placeholder="Sélectionner un marché" :disabled="isLoading" />
                            </Field>
                            <ErrorMessage name="secteur" class="text-danger" />
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xm-12">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Secteur
                            </label>
                            <Field name="secteur" v-model="secteurs" v-slot="{ field }">
                                <Multiselect mode="tags" :options="secteursOptions" :searchable="true" v-bind="field"
                                    placeholder="Sélectionner un secteur" :disabled="isLoading" />
                            </Field>
                            <ErrorMessage name="secteur" class="text-danger" />
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xm-12">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Etats
                            </label>
                            <Field name="etat" v-model="etat" v-slot="{ field }">
                                <Multiselect :options="etatOptions" :searchable="true" v-bind="field"
                                    placeholder="Sélectionner un état" :disabled="isLoading" />
                            </Field>
                            <ErrorMessage name="etat" class="text-danger" />
                        </div>
                    </div>
                </div>
            </div>
            <hr />
            <div class="table-responsive">
                
                <!-- Message d'état vide -->
                <div v-if="!isLoading && usagers.length === 0" class="text-center py-5">
                    <div class="mb-3">
                        <i class="fas fa-search text-muted" style="font-size: 3rem;"></i>
                    </div>
                    <h5 class="text-muted mb-2">Aucune donnée trouvée</h5>
                    <p class="text-muted">Aucun emplacement ne correspond à vos critères de recherche.</p>
                </div>

                <table v-else class="table text-nowrap align-middle mb-0">
                    <thead>
                        <tr>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                A Code
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                N Code
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Type Place
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Matricule Loc
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Locataire
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Categorie Activite Loc
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Activite Loc
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Détail Activite Exp
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Matricule Exp
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Exploitant
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Categorie Activite Exp
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Activite Exp
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Détail Activite Exp
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Catégorie Activite Place
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Activite Place
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Etat
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Encours Payés
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Encours Dû
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Arrièrés Payés
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Arrièrés Dû
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Total Payé
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Dette Totale
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(emp, index) in usagers" :key="index">
                            <td class="shadow-none lh-1 fw-medium text-primary">
                                {{ emp.emplacement_codeemp }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-primary">
                                {{ emp.emplacement_ncode_emp }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-primary">
                                {{ emp.type_emplacement_libelle_type_emp }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-primary">
                                {{ emp.locataire_matricule }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-primary">
                                {{ emp.locataire_full_name }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ afficher20Caracteres(emp.locataire_activite) }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ afficher20Caracteres(emp.locataire_new_activite) }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ afficher20Caracteres(emp.locataire_nouveau_activite) }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-primary">
                                {{ emp.exploitant_matricule }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-primary">
                                {{ emp.exploitant_full_name }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ afficher20Caracteres(emp.exploitant_activite) }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ afficher20Caracteres(emp.exploitant_new_activite) }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ afficher20Caracteres(emp.exploitant_nouveau_activite) }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ afficher20Caracteres(emp.activite_activite_nom) }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ afficher20Caracteres(emp.activite_activite_nom) }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ (parseFloat(emp.totalAPayer)) > 0 ? "Endetté" : "A jour" }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ separateur((parseFloat(emp.totalPayeEncours))) }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                <b> {{ separateur(parseFloat(emp.resteAPayerEncours)) }}</b>
                            </td>
                             <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ separateur((parseFloat(emp.totalPayeEncours)) ) }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                <b> {{ separateur((parseFloat(emp.totalArrieres)) ) }}</b>
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ separateur((parseFloat(emp.totalPayeEncours) + (parseFloat(emp.totalPayeEncours)) ) ) }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                               <b class="text-danger fw-bold fs-14"> {{ separateur((parseFloat(emp.totalAPayer)) ) }}</b>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
                <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit"
                    @paginate="handlePaginate" />
            </div>
        </div>
    </div>
    <AddUsagerModal :item="selectedItem" @close="recharger" @open="show_Modal" />
</template>
<script lang="ts">
import { ref, defineComponent, onMounted, watch } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import AddUsagerModal from "./Emplacement.vue";
import Multiselect from '@vueform/multiselect';

import {
    showModal,
    suppression,
    separateur,
    format_Date,
    format_date,
    supprimerElement,
    error,
    dateActuelle,
    success,
    getUrlApiForFiles,
    afficher20Caracteres,
    downloadExcel,
} from "@/utils/utils";
import { Contrat } from "@/models/Contrat";
import ApiService from "@/services/ApiService";
import { Option } from "@/models/Option";
import PaginationComponent from "@/components/Utilities/Pagination.vue";
import JwtService from "@/services/JwtService";
import axios from "axios";
import Swal from "sweetalert2";
import ListeArrieresContratPage from '@/pages/ArrieresContrat/ListeArrieresContratPage.vue';

export default defineComponent({
    name: "ListeUsager",
    components: {
        PaginationComponent,
        Field,
        Multiselect,
        ErrorMessage,
        AddUsagerModal,
    },
    setup: () => {
        // BEGIN PAGINATE
        const searchTerm = ref("");
        const page = ref(1);
        const totalPages = ref(0);
        const limit = ref(10);
        const totalElements = ref(0);
        const secteursOptions = ref<Array<Option>>([]);
        const motCle = ref("");
        const dateFin = ref(dateActuelle());
        const dateDebut = ref(dateActuelle());
        const lemontant = ref("0");
        const secteurs = ref([]);
        const marches = ref([]);
        const donn = ref();
        const etat = ref();
        const etatOptions = ref([
            {
                label: "A jour",
                value: "A_jour",
            },
            {
                label: "Arrièrés",
                value: "Arrièrés",
            },
            {
                label: "Impayé",
                value: "Impayé",
            }
        ])
        const selectedItem = ref();
        const show_Modal = (el) => {
            showModal(el);
            selectedItem.value = 0;
        };

        const ajouterUsager = () => {
            selectedItem.value = null;
        };

        const modifUsager = (usager) => {
            selectedItem.value = usager;
        };
        // END PAGINATE
        const handlePaginate = ({ page_, limit_ }) => {
            try {
                page.value = page_;
                limit.value = limit_;
                actionRecherche(page_, limit_);
            } catch (error) {
                //
            }
        };

        const telecharger = async () => {
            valideEtape3.value = false;
            try {
                const element = {
                    motCle: motCle.value,
                    secteurs: secteurs.value,
                    marches: marches.value,
                };
                const response = await axios.post("/liste/usager/emplacement/export", element);
                const downloadUrl = await getUrlApiForFiles("Excel", response.data.data + ".xlsx");

                await downloadExcel(downloadUrl);
                openNewWindow({ reference: (response.data.data) }, "Excel");
                valideEtape3.value = true;
            } catch (err) {
                if (axios.isAxiosError(err) && err.response) {
                    error(err.response.data.message || err.message);
                } else {
                    if (err instanceof Error) {
                        error(err.message);
                    } else {
                        error(String(err));
                    }
                }
                valideEtape3.value = true;
            }
        };

        const recupereSecteurs = async () => {
            try {
                const response = await axios.get('/secteur');
                const donneee = response.data.data;
                secteursOptions.value = donneee.map((secteur) => ({
                    label: `${secteur.code_secteur} -- [ ${secteur.libelle_secteur} ]`,
                    value: secteur.code_secteur,
                    disabled: false
                }));
                return secteursOptions.value;
            } catch (error) {
                //
            }
        }

        const marcheOptions = ref<Array<Option>>([]);
        const recupereMarches = async () => {
            try {
                const response = await axios.get('/marches');
                const donneee = response.data.data;
                marcheOptions.value = donneee.map((marche) => ({
                    label: `${marche.id} -- [ ${marche.nomMarche} ]`,
                    value: marche.id,
                }));
                return marcheOptions.value;
            } catch (error) {
                //
            }
        }


        const valideEtape3 = ref(true);
        const isLoading = ref(false);
        const recharger = () => {
            actionRecherche(page.value, limit.value);
        };
        const agent = ref();
        const agentOptions = ref();
        const usagers: any = ref<Array<any>>([]);

        const openAndPrint = (url: string) => {
            const newWindow = window.open(url, "_blank");

            if (newWindow) {
                newWindow.onload = () => {
                    newWindow.print();
                };
            } else {
                console.error("Impossible d'ouvrir la fenêtre");
            }
        };
        function openNewWindow(data: any, dossier = "Excel") {
            openAndPrint(getUrlApiForFiles(dossier, data.reference + ".xlsx"));
        }
        const actionRecherche = async (page = 1, limi = 10, searchTerm = "") => {
            isLoading.value = true;
            const element = {
                motCle: motCle.value,
                page: page,
                secteurs: secteurs.value,
                marches: marches.value,
                totalPages: totalPages.value,
                limit: limi,
                totalElements: totalElements.value,
                mot: searchTerm,
                etat: etat.value,
            };
            donn.value = element;
            try {
                const response = await axios.post("/liste/usager/emplacement", element);
                // Utiliser les données raw au lieu des entities
                usagers.value = response.data.data.data.raw;
                totalPages.value = response.data.data.totalPages;
                limit.value = response.data.data.limit;
                totalElements.value = response.data.data.totalElements;
            } catch (err) {
                if (axios.isAxiosError(err) && err.response) {
                    error(err.response.data.message || err.message);
                } else {
                    if (err instanceof Error) {
                        error(err.message);
                    } else {
                        error(String(err));
                    }
                }
            } finally {
                isLoading.value = false;
            }
        };
        watch(motCle, (newValue, oldValue) => {
            page.value = 1;
            limit.value = 10;
            totalPages.value = 0;
            totalElements.value = 0;
            motCle.value = newValue;
            actionRecherche(page.value, limit.value);
        });
        watch(secteurs, (newValue, oldValue) => {
            page.value = 1;
            limit.value = 10;
            totalPages.value = 0;
            totalElements.value = 0;
            secteurs.value = newValue;
            actionRecherche(page.value, limit.value);
        });
        watch(marches, (newValue, oldValue) => {
            page.value = 1;
            limit.value = 10;
            totalPages.value = 0;
            totalElements.value = 0;
            marches.value = newValue;
            actionRecherche(page.value, limit.value);
        });
        watch(etat, (newValue, oldValue) => {
            page.value = 1;
            limit.value = 10;
            totalPages.value = 0;
            totalElements.value = 0;
            etat.value = newValue;
            actionRecherche(page.value, limit.value);
        });
        onMounted(async () => {
            await recupereSecteurs();
            await recupereMarches();
            await actionRecherche(1, 10);
        });
        return {
            telecharger,
            secteurs,
            marches,
            dateDebut,
            dateFin,
            suppression,
            recharger,
            page,
            agentOptions,
            agent,
            openNewWindow,
            usagers,
            secteursOptions,
            totalPages,
            limit,
            format_date,
            format_Date,
            separateur,
            totalElements,
            handlePaginate,
            searchTerm,
            motCle,
            error,
            lemontant,
            valideEtape3,
            selectedItem,
            afficher20Caracteres,
            show_Modal,
            ajouterUsager,
            modifUsager,
            dateActuelle,
            marcheOptions,
            recupereMarches,
            etat,
            etatOptions,
            isLoading,
        };
    },
});
</script>

<style scoped>
/* Animation pour les spinners dans les labels */
.spinner-border-sm {
    animation: spinner-border 0.75s linear infinite;
}

/* Amélioration du loader overlay pour tout le composant */
.position-relative .position-absolute {
    backdrop-filter: blur(3px);
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

/* Animation fade pour le contenu */
.table {
    transition: opacity 0.3s ease-in-out;
}

/* Style pour le message d'état vide */
.text-center.py-5 {
    background-color: #f8f9fa;
    border-radius: 8px;
    margin: 20px 0;
}

/* Amélioration des champs désactivés */
.form-control:disabled,
.multiselect.is-disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

/* Animation pour le loader principal */
.spinner-border {
    animation: spinner-border 0.75s linear infinite;
}

/* Effet de pulsation pour le texte du loader */
@keyframes pulse {
    0% { opacity: 1; }
    50% { opacity: 0.7; }
    100% { opacity: 1; }
}

.text-muted {
    animation: pulse 2s ease-in-out infinite;
}
</style>